import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from '../../../core/services/shared/analytics.service';

@Component({
  selector: 'app-analytics-consent',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (analytics.configured && analytics.preferenceOpen()) {
      <section class="analytics-notice" role="region" aria-label="Analytics preferences">
        <div>
          <strong>Usage analytics</strong>
          <p>May we use Google Analytics cookies to understand page visits and improve this website?
            Cookies recognise repeat visits from the same browser, not your identity.
            Your contact-form details are not included.
            <a routerLink="/privacy-policy">Privacy policy</a></p>
          @if (analytics.doNotTrack) { <p>Your browser's Do Not Track preference keeps analytics disabled.</p> }
        </div>
        <div class="actions">
          <button type="button" (click)="analytics.setConsent(false)">Decline</button>
          <button type="button" class="allow" [disabled]="analytics.doNotTrack" (click)="analytics.setConsent(true)">Allow analytics</button>
        </div>
      </section>
    }
  `,
  styles: [`
    .analytics-notice { position: fixed; bottom: 1rem; left: 1rem; right: 1rem; z-index: 1200;
      max-width: 64rem; margin: auto; background: #0b1a2e; color: #fff; padding: 1rem 1.25rem;
      border: 1px solid #c6a57a; border-radius: .75rem; box-shadow: 0 4px 24px #0005;
      display: flex; align-items: center; gap: 1rem; }
    p { margin: .35rem 0 0; line-height: 1.5; font-size: .9rem; }
    a { color: #9ed9f4; text-decoration: underline; }
    .actions { display: flex; gap: .5rem; flex-shrink: 0; }
    button { background: transparent; color: #fff; border: 1px solid #a2aaba; border-radius: .4rem;
      padding: .65rem .85rem; cursor: pointer; font: inherit; font-size: .9rem; }
    button.allow { background: #c6a57a; color: #0b1a2e; border-color: #c6a57a; }
    button:focus-visible, a:focus-visible { outline: 3px solid #9ed9f4; outline-offset: 3px; }
    button:disabled { opacity: .5; cursor: default; }
    @media (max-width: 640px) { .analytics-notice { flex-direction: column; align-items: stretch; }
      .actions button { flex: 1; } }
  `],
})
export class AnalyticsConsentComponent {
  readonly analytics = inject(AnalyticsService);
}
